import React from "react";
import {Link, useLocation, useNavigate, useParams} from "react-router-dom";
import { motion } from "framer-motion";
import styles from "./OfferDetail.module.scss";
import { FaUsers, FaUser, FaChild, FaHeart, FaTrophy } from "react-icons/fa";

const offerDetails = {
  grupni: {
    title: "Grupni časovi",
    description:
      "Raznovrstan program – naučite preko 10 interesantnih plesova. Zabava i učenje – spojite zabavu sa učenjem novih veština. Fizička aktivnost – poboljšajte svoju kondiciju i fleksibilnost.\n\nFOKUS je na druženju i uživanju u pozitivnoj plesnoj atmosferi. Oslobađanje STRESA kroz ples. Sticanje PRIJATELJA za ceo život.",
    icon: <FaUsers />,
  },
  individualni: {
    title: "Individualni časovi",
    description:
      "Raznovrstan program – mogućnost odabira različitih plesnih stilova. Personalizovani plan – formira se u skladu sa vašim veštinama i napretkom. Fleksibilnost – časovi se prilagođavaju vašim obavezama.\n\nFOKUS je na individualnosti i fleksibilnosti. Usavršavanje plesne TEHNIKE. Praćenje vašeg NAPRETKA i RAZVOJA.",
    icon: <FaUser />,
  },
  deca: {
    title: "Časovi za decu",
    description:
      "Razvoj veština – razvijanje fizičke i mentalne sposobnosti dece. Kreativna atmosfera – učenje plesa kroz igru. Timski duh – podsticanje zajedništva i pristupa obavezama.\n\nFOKUS je na pravilnom razvoju dece. Jačanje mišića i ISPRAVNE POSTURE. Jačanje SAMOPOUZDANJA i izražavanje emocija.",
    icon: <FaChild />,
  },
  mladenacki: {
    title: "Prvi mladenčki ples",
    description:
      "Individualni časovi za parove – pravljenje koreografije i spremanje za prvi mladenčki ples. Personalizovani plan – formiranje programa u skladu sa vašim željama i veštinama. Fleksibilnost – časovi se prilagođavaju vašim obavezama.\n\nFOKUS je na individualnom pristupu svakom paru. Uživanje u romantičnoj atmosferi pripreme za prvi ples. Usavršavanje koraka i jačanje SAMOPOUZDANJA.",
    icon: <FaHeart />,
  },
  takmicarski: {
    title: "Takmičarski ples",
    description:
      "Kondicioni i plesni treninzi (grupni i individualni). Učešće na domaćim i stranim takmičenjima i festivalima. Organizovanje zimskih i letnjih kampova sa gostujućim trenerima.\n\nFOKUS je na tehnici plesa, kondiciji i fizičkoj spremi takmičara. Razvijanje DISCIPLINE i odgovornosti prema plesu. Jačanje TIMSKOG duha.",
    icon: <FaTrophy />,
  },
};


const OfferDetail = () => {
  const { offerId } = useParams();
  const offer = offerDetails[offerId];


  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (sectionId) => {
    if (location.pathname !== "/") {
      // Ako nisi na "/" -> idi na "/"
      navigate("/");

      // Sačekaj da se ruta promeni, pa onda skroluj
      setTimeout(() => {
        document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
      }, 100); // Blaga pauza da sačekamo učitavanje stranice
    } else {
      // Ako si već na "/" -> samo skroluj
      document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  if (!offer) return <p>Ne postoji tražena ponuda.</p>;

  return (
    <motion.section
      className={styles.offerDetail}
      initial={{ opacity: 0, x: -50 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: 50 }}
      transition={{ duration: 0.5 }}
    >
      <div className={styles.icon}>{offer.icon}</div>
      <div className={styles.content}>
        <h2>{offer.title}</h2>
        <p>{offer.description}</p>
        <Link onClick={handleNavigation("ponuda")} className={styles.backButton}>Nazad</Link>
      </div>
    </motion.section>
  );
};

export default OfferDetail;